import { createSlice } from '@reduxjs/toolkit';

// initial state
const initialState = {
	isLoggedIn: false,
	test: false,
	token: '',
	tenantId: '',
	userProfileId: '',
	personalDetailId: '',
	roleId: '',
	departmentId: '',
	departmentName: '',
	firstName: '',
	fullName: '',
	email: '',
	mainMenu: [],
	userId: '',
	clientId: '',
};
// active account slice
export const activeAccountSlice = createSlice({
	name: 'activeAccount',
	initialState,
	reducers: {
		setLoggedIn: (state, action) => {
			state.isLoggedIn = action.payload;
		},
		setEmptyLoggedIn: (state) => {
			state.isLoggedIn = '';
		},
		setToken: (state, action) => {
			// debugger;
			state.token = action.payload;
		},
		setUserDetails: (state, action) => {
			state.userDetails = action.payload;
		},
		setUserId: (state, action) => {
			state.userId = action.payload;
		},
		setEmptyUserId: (state) => {
			state.userId = '';
		},
		setClientId: (state, action) => {
			state.clientId = action.payload;
		},
		setEmptyClientId: (state) => {
			state.clientId = '';
		},
		setEmptyToken: (state) => {
			state.token = '';
		},
		setMainMenu: (state, action) => {
			state.mainMenu = action.payload;
		},
		setTenantId: (state, action) => {
			state.tenantId = action.payload;
		},
		setEmptyTenantId: (state) => {
			state.tenantId = '';
		},
		setUserProfileId: (state, action) => {
			state.userProfileId = action.payload;
		},
		setEmptyUserProfileId: (state) => {
			state.userProfileId = '';
		},
		setPersonalId: (state, action) => {
			state.personalDetailId = action.payload;
		},
		setEmptyPersonalId: (state) => {
			state.personalDetailId = '';
		},
		setRoleId: (state, action) => {
			state.roleId = action.payload;
		},
		setEmptyRoleId: (state) => {
			state.roleId = '';
		},
		setDepartmentId: (state, action) => {
			state.departmentId = action.payload;
		},
		setEmptyDepartmentId: (state) => {
			state.departmentId = '';
		},
		setDepartmentName: (state, action) => {
			state.departmentName = action.payload;
		},
		setEmptyDepartmentName: (state) => {
			state.departmentName = '';
		},
		setUserEmail: (state, action) => {
			state.email = action.payload;
		},
		setEmptyUserEmail: (state) => {
			state.email = '';
		},
		setFirstName: (state, action) => {
			state.firstName = action.payload;
		},
		setEmptyFirstName: (state) => {
			state.firstName = '';
		},
		setFullName: (state, action) => {
			state.fullName = action.payload;
		},
		setEmptyFullName: (state) => {
			state.fullName = '';
		},
		setTest: (state) => {
			state.test = true;
		},
		setTestDefault: (state) => {
			state.test = false;
		},
	},
});

export const {
	setLoggedIn,
	setEmptyLoggedIn,
	setToken,
	setEmptyToken,
	setMainMenu,
	setUserDetails,
	setUserId,
	setEmptyUserId,
	setClientId,
	setEmptyClientId,
	setTenantId,
	setEmptyTenantId,
	setUserProfileId,
	setEmptyUserProfileId,
	setPersonalId,
	setEmptyPersonalId,
	setRoleId,
	setEmptyRoleId,
	setDepartmentId,
	setEmptyDepartmentId,
	setDepartmentName,
	setEmptyDepartmentName,
	setUserEmail,
	setEmptyUserEmail,
	setFirstName,
	setEmptyFirstName,
	setFullName,
	setEmptyFullName,
	setTest,
	setTestDefault,
} = activeAccountSlice.actions;

export default activeAccountSlice.reducer;
